const ThreeDotLoading = () => {
  return (
    <div class="flex space-x-1 w-full justify-center  ">
      <div class="w-2 h-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div class="w-2 h-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div class="w-2 h-2 bg-white rounded-full animate-bounce"></div>
    </div>
  );
};

export default ThreeDotLoading;
